import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {CURRENCY_ITEMS} from '../../../constants';
import {COUNTRIES} from '../../../constants/countries';
import {TDetails, TListItem} from '@/api/merchant/bank/types';
import {TUUID} from '@/types';

export const getAccountList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return {
      id: faker.datatype.uuid(),
      fiat_code: faker.finance.currencyCode(),
      iban: faker.datatype.uuid(),
      swift_code: faker.name.findName(),
      name: faker.name.findName(),
      primary: faker.datatype.boolean(),
      status: (faker.helpers as any).arrayElement(['active', 'inactive']),
    } as TListItem;
  });
};

export const getAccountDetails = (): TDetails => {
  const countries = COUNTRIES.reduce((acc: TUUID[], country) => {
    acc.push(country[1]);
    return acc;
  }, []);

  const currencies = CURRENCY_ITEMS.reduce((acc: TUUID[], currency) => {
    acc.push(currency.id);
    return acc;
  }, []);

  return {
    id: faker.datatype.uuid(),
    fiat_code: (faker.helpers as any).arrayElement(currencies),
    swift_code: 'TICSRUMM',
    name: faker.finance.accountName(),
    iban: faker.finance.iban(),
    routing_code: faker.finance.iban(),
    country: (faker.helpers as any).arrayElement(countries),
    primary: faker.datatype.boolean(),
  } as TDetails;
};
